import { render, staticRenderFns } from "./Bebidas.vue?vue&type=template&id=410a7b2a"
import script from "./Bebidas.vue?vue&type=script&lang=js"
export * from "./Bebidas.vue?vue&type=script&lang=js"
import style0 from "./Bebidas.vue?vue&type=style&index=0&id=410a7b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports